import { Box, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import './hero.css';

const HeroTitle = () => {
    const {t} = useTranslation();

    return (
        <>
            <Stack
                position='relative'
                direction='row'
                pt={{xs: 5, md: 0}}
                sx={{
                    overflow: 'hidden'
                }}
            >
                {/* Title - Learn */}
                <div
                    data-aos="zoom-in"
                    data-aos-easing="ease-out-back"
                >
                    <Typography
                        sx={{
                            fontWeight: 700,
                            color: 'white',
                            fontSize: {xs: '13vw', md: '14vw'},
                            transform: {xs: 'rotate(-5deg) translate(10px, -50px)', md: 'rotate(-5deg) translate(0px, -50px)'}
                        }}
                    >
                        {t('hero.title.title-1')}
                    </Typography>
                </div>

                {/* Title - With */}
                <div
                    data-aos="zoom-in"
                    data-aos-easing="ease-out-back"
                    data-aos-delay="100"
                    style={{
                        animation: 'titleWith 1s infinite linear 0.1s'
                    }}
                >
                    <Typography
                        sx={{
                            fontWeight: 900,
                            color: 'white',
                            fontSize: '3.5vw',
                            transform: {xs: 'translate(10px, -35px)', sm: 'translate(0px, -15px)', md: 'translate(0px, 20px)'}
                        }}
                    >
                        {t('hero.title.title-2')}
                    </Typography>
                </div>

                {/* Title - Cuddles */}
                <div
                    data-aos="zoom-in"
                    data-aos-easing="ease-out-back"
                    data-aos-delay="200"
                >
                    <Typography
                        sx={{
                            fontWeight: 700,
                            color: 'white',
                            fontSize: {xs: '13vw', md: '14vw'},
                            transform: {xs: 'rotate(5deg) translate(-20px, -25px)', sm: 'rotate(5deg) translate(-50px, 0px)', md: 'rotate(5deg) translate(-100px, 50px)'},
                            zIndex: 2
                        }}
                    >
                        {t('hero.title.title-3')}
                    </Typography>
                </div>

                {/* Fish - Top Left */}
                <Box
                    sx={{
                        width: '12vw',
                        position: 'absolute',
                        transform: {xs: 'translate(25px, -45px)', md: 'translate(50px, 0px)'}
                    }}
                >
                    <div
                        data-aos="fade-up"
                        data-aos-duration="1000"
                        data-aos-delay="300"
                    >
                        <img 
                            src="/images/game/Fish-1.png" 
                            alt="Fish" 
                            width='100%'
                            style={{
                                animation: 'fish1Animation 2s infinite'
                            }}
                        />
                    </div>
                </Box>

                {/* Fish - Top right */}
                <Box
                    sx={{
                        width: '6vw',
                        position: 'absolute',
                        right: 0,
                        zIndex: 1,
                        transform: {xs: 'translate(-30px, -5px)', sm: 'translate(-100px, 40px)', md: 'translate(-125px, 125px)'}
                    }}
                >
                    <div
                        data-aos="zoom-in"
                        data-aos-duration="1000"
                        data-aos-delay="400"
                    >
                        <img 
                            src="/images/game/Fish-4.png" 
                            alt="Fish" 
                            width='100%'
                            style={{
                                animation: 'fish2Animation 2s infinite'
                            }}
                        />
                    </div>
                </Box>

                {/* Fish - Bottom right */}
                <Box
                    sx={{
                        width: '12vw',
                        position: 'absolute',
                        right: 0,
                        bottom: 0,
                        transform: {
                            xs: 'translate(-80px, -20px) scaleX(-1)', 
                            sm: 'translate(-250px, 10px) scaleX(-1)', 
                            md: 'translate(-300px, 20px) scaleX(-1)', 
                            lg: 'translate(-400px, 20px) scaleX(-1)'
                        },
                        zIndex: 2
                    }}
                >
                    <div
                        data-aos="fade-left"
                        data-aos-duration="1000"
                        data-aos-delay="500"
                    >
                        <img 
                            src="/images/game/Fish-2.png" 
                            alt="Fish" 
                            width='100%'
                            style={{
                                animation: 'fish3Animation 5s infinite'
                            }}
                        />
                    </div>
                </Box>
            </Stack>
        </>
    );
}

export default HeroTitle;